import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MenuItem } from "@mui/material";
import { t } from "i18next";
import api from "../../../../../helpers/api/Api";
import ApiUrls from "../../../../../helpers/urls/ApiUrls";
import RouteUrls from "../../../../../helpers/urls/RouteUrls";
import SelectCustom from "../../../../../components/SelectCustom";
import CustomDialog from "../../../../../components/Dialog";

function SelectAnycast({ value, onChange, error }) {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [anycasts, setAnycasts] = useState([]);
  const [userLoading, setUserLoading] = useState(true);

  useEffect(() => {
    getUser();
  }, []);

  const getUser = () => {
    const userId = JSON.parse(localStorage.getItem("user"))?.id;

    const formData = new FormData();
    formData.append("uid", userId);

    api.post(ApiUrls.user.list, formData)
      .then((response) => {
        setAnycastsList(response.data.data[0].anycastips);
      })
      .catch((error) => {
        setUserLoading(false);
      });
  }

  const setAnycastsList = (anycastips) => {
    const userAnycast = anycastips ? anycastips.split(",") : [];
    userAnycast.sort();
    setAnycasts(userAnycast);
    setUserLoading(false);

    if (userAnycast.length === 0) {
      setOpenDialog(true);
    }
  }

  return (
     <>
       <SelectCustom
          id="anycast-select"
          value={value}
          error={error}
          label={t("site.anycast")}
          onChange={onChange}
          loading={userLoading}
       >
         {anycasts.map((anycast, i) => {
           return (
              <MenuItem value={anycast} key={`anycast-${i}`}>
                {anycast}
              </MenuItem>
           )
         })}
       </SelectCustom>

       <CustomDialog
          open={openDialog}
          text={
            <div className="mt-3 mx-3">
              {t("domain.domain_add_no_anycast")}
            </div>
          }
          confirmCenter
          onAccept={() => navigate(RouteUrls.domain.list)}
       />
     </>
  );
}

export default SelectAnycast;
